import * as React from 'react'

export function useImageZoom() {
  const [zoomLevel, setZoomLevel] = React.useState(1)
  const [position, setPosition] = React.useState({ x: 0, y: 0 })
  const [isDragging, setIsDragging] = React.useState(false)
  const dragStartRef = React.useRef({ x: 0, y: 0 })

  const handleZoomIn = React.useCallback(() => setZoomLevel(prev => Math.min(prev + 0.2, 3)), [])
  const handleZoomOut = React.useCallback(() => setZoomLevel(prev => Math.max(prev - 0.2, 0.5)), [])
  const resetZoom = React.useCallback(() => {
    setZoomLevel(1)
    setPosition({ x: 0, y: 0 })
  }, [])

  const handleMouseDown = React.useCallback(
    (e: React.MouseEvent) => {
      if (zoomLevel > 1) {
        setIsDragging(true)
        dragStartRef.current = { x: e.clientX - position.x, y: e.clientY - position.y }
      }
    },
    [zoomLevel, position]
  )
  const handleMouseMove = React.useCallback(
    (e: React.MouseEvent) => {
      if (isDragging) {
        setPosition({
          x: e.clientX - dragStartRef.current.x,
          y: e.clientY - dragStartRef.current.y,
        })
      }
    },
    [isDragging]
  )
  const handleMouseUpOrLeave = React.useCallback(() => setIsDragging(false), [])

  return {
    zoomLevel,
    position,
    isDragging,
    handleZoomIn,
    handleZoomOut,
    resetZoom,
    handleMouseDown,
    handleMouseMove,
    handleMouseUpOrLeave,
  }
}
